import { SectionWrapperProps } from '../../../atoms/Section/types';
import { SectionBackgroundMode, SectionGutterMode } from '../../../atoms/Section/enums';

export const defaultSectionWrapperProps: SectionWrapperProps = {
  backgroundMode: SectionBackgroundMode.Grey,
  gutterTop: SectionGutterMode.Regular,
  gutterBottom: SectionGutterMode.Regular,
  isFullWidth: true,
};
